
import backButtonOutlined from "../common/back-button-outlined.vue";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  components: { backButtonOutlined },
  props: {
    currentStep: {
      type: Number,
      default: 0
    },
    currentStepItem: {
      type: Object,
      default: {}
    },
    steps: {
      type: Array,
      default: () => []
    },
    itemsWithoutTaxes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isValid: false
    };
  },
  computed: {
    ...mapGetters("menu", [
      "getMenuUploadList",
      "getItemsWithMandatoryButUnassignedDescriptions",
      "getItemsWithoutPrice"
    ]),
    ...mapState("menu", [
      "menuUploadRawData",
      "menuUploadList",
      "menuUploadImageList",
      "menuUploadExceededCharLimitList",
      "menuUploadFieldMap"
    ]),
    itemsWithoutPackageCharge() {
      return this.menuUploadList.filter((item) => !item.package_charge);
    }
  },
  watch: {
    getMenuUploadList: {
      handler(val) {
        this.handleCheckValid();
      },
      deep: true
    },
    menuUploadRawData() {
      this.handleCheckValid();
    },
    currentStep() {
      this.handleCheckValid();
    },
    currentStepItem() {
      this.handleCheckValid();
    }
  },
  methods: {
    ...mapMutations("menu", ["SET_MENU_UPLOAD_DRAG_SELECTION"]),
    ...mapActions("menu", ["resetFilters"]),
    handleCheckValid() {
      this.$nextTick(() => {
        this.isValid = this.menuUploadList.length;
      });
    },

    getStepColor(index) {
      if (index < this.currentStep) return "green";
      if (index === this.currentStep) return "#FF9A24";
      return "#f4f4f4";
    },
    isCompletedStep(index) {
      return index < this.currentStep;
    },
    goTo(index) {
      if (this.isCompletedStep(index)) {
        this.$nuxt.$emit("clear-menu-upload-item-selection");
        this.SET_MENU_UPLOAD_DRAG_SELECTION([]);
        this.$emit("goToStep", index);
      }
    },
    handleShowToast() {
      this.$nuxt.$emit("show-toast", {
        text: "Dummy text warning here",
        color: "orange lighten-1",
        icon: "mdi-alert-circle-outline",
        flat: true
      });
    },
    handleGoToNext() {
      if (this.currentStepItem.id === "mapping-step") {
        const allRequiredFieldsValid = this.currentStepItem?.attributes
          .filter((el) => el.required)
          .every((item) =>
            this.menuUploadFieldMap?.some(
              (field) => field?.value && field?.value === item?.value
            )
          );
        if (!allRequiredFieldsValid) {
          this.$emit("show-mapping-validation-dialog");
          return;
        }
      }

      if (this.currentStepItem.id === "configure-charges") {
        if (this.itemsWithoutPackageCharge.length) {
          this.$emit("show-unassigned-packaging-charge-dialog");
          return;
        } else {
          if (this.getItemsWithoutPrice.length) {
            this.$emit("show-price-missing-dialog");
            return;
          }
        }
      }
      if (this.currentStepItem.id === "verify-items") {
        if (this.menuUploadExceededCharLimitList.length) {
          this.$emit("show-character-limit-dialog");
          return;
        }
      }
      if (this.currentStepItem.id === "set-tax") {
        if (this.itemsWithoutTaxes.length > 0) {
          this.$emit("show-tax-mandatory-dialog");
          return;
        }
      }
      if (this.currentStepItem.id === "add-photos") {
        const unassignedPhotoCount = this.menuUploadImageList.filter(
          (img) => !img.itemId
        ).length;
        const data = {
          step: this.currentStep + 1,
          unassignedPhotoCount
        };
        if (unassignedPhotoCount) {
          this.$emit("open-unassigned-warning-dialog", data);
          return;
        }
      } else if (this.currentStepItem.id === "add-description") {
        if (this.getItemsWithMandatoryButUnassignedDescriptions.length > 0) {
          this.$emit("show-description-warning-dialog");
          return;
        }
      } else if (
        ["dish-type", "set-category"].includes(this.currentStepItem.id)
      ) {
        const isValid = this.getMenuUploadList.every(
          (el) => !!el[this.currentStepItem.property]
        );
        if (!isValid) {
          this.$emit("show-mandatory-assign-dialog");
          return;
        }
        this.$nuxt.$emit("clear-menu-upload-item-selection");
        this.SET_MENU_UPLOAD_DRAG_SELECTION([]);
      }

      this.resetFilters();
      this.$emit("increment-step", this.currentStep + 1);
    }
  }
};
